/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransformStepDto } from './TransformStepDto';
import {
    TransformStepDtoFromJSON,
    TransformStepDtoFromJSONTyped,
    TransformStepDtoToJSON,
    TransformStepDtoToJSONTyped,
} from './TransformStepDto';
import type { TransformConfigDto } from './TransformConfigDto';
import {
    TransformConfigDtoFromJSON,
    TransformConfigDtoFromJSONTyped,
    TransformConfigDtoToJSON,
    TransformConfigDtoToJSONTyped,
} from './TransformConfigDto';

/**
 * 
 * @export
 * @interface FieldMappingDto
 */
export interface FieldMappingDto {
    /**
     * 
     * @type {string}
     * @memberof FieldMappingDto
     */
    csvColumn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldMappingDto
     */
    targetField?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldMappingDto
     */
    transform?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FieldMappingDto
     */
    required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FieldMappingDto
     */
    defaultValue?: string | null;
    /**
     * 
     * @type {TransformConfigDto}
     * @memberof FieldMappingDto
     */
    transformConfig?: TransformConfigDto;
    /**
     * 
     * @type {Array<TransformStepDto>}
     * @memberof FieldMappingDto
     */
    transformSteps?: Array<TransformStepDto> | null;
}

/**
 * Check if a given object implements the FieldMappingDto interface.
 */
export function instanceOfFieldMappingDto(value: object): value is FieldMappingDto {
    return true;
}

export function FieldMappingDtoFromJSON(json: any): FieldMappingDto {
    return FieldMappingDtoFromJSONTyped(json, false);
}

export function FieldMappingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldMappingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'csvColumn': json['csvColumn'] == null ? undefined : json['csvColumn'],
        'targetField': json['targetField'] == null ? undefined : json['targetField'],
        'transform': json['transform'] == null ? undefined : json['transform'],
        'required': json['required'] == null ? undefined : json['required'],
        'defaultValue': json['defaultValue'] == null ? undefined : json['defaultValue'],
        'transformConfig': json['transformConfig'] == null ? undefined : TransformConfigDtoFromJSON(json['transformConfig']),
        'transformSteps': json['transformSteps'] == null ? undefined : ((json['transformSteps'] as Array<any>).map(TransformStepDtoFromJSON)),
    };
}

export function FieldMappingDtoToJSON(json: any): FieldMappingDto {
    return FieldMappingDtoToJSONTyped(json, false);
}

export function FieldMappingDtoToJSONTyped(value?: FieldMappingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'csvColumn': value['csvColumn'],
        'targetField': value['targetField'],
        'transform': value['transform'],
        'required': value['required'],
        'defaultValue': value['defaultValue'],
        'transformConfig': TransformConfigDtoToJSON(value['transformConfig']),
        'transformSteps': value['transformSteps'] == null ? undefined : ((value['transformSteps'] as Array<any>).map(TransformStepDtoToJSON)),
    };
}

